export default class DataExchange {
  /**
   * @param {HTMLFormElement} form 
   */
  constructor (form) {
    this.form = form
  }

  get data () { throw new Error(`Not implemented in ${this.constructor.name}`)}
  get queryComponent () { throw new Error(`Not implemented in ${this.constructor.name}`) }
  set data (value) { throw new Error(`Not implemented in ${this.constructor.name}`) }
}



// WEBPACK FOOTER //
// ./src/services/DataExchange.js